// +----------------------------------------------------------------------
// | 决策接口（Phase 3 后端就绪后即可直接使用，契约见架构文档 8.2）
// +----------------------------------------------------------------------
import request from '../lib/request';

/**
 * 创建决策（AI 首次分析）
 * @param {{question:string, mode?:'normal'|'quick'|'random'}} data
 * @returns {Promise<object>} 决策对象（含 understanding/options/factors/next/ai_message）
 */
export function createDecision(data) {
  return request.post('/decisions', data);
}

/**
 * 决策列表 / 历史
 * @param {{page?:number, page_size?:number, category?:string, status?:string}} params
 */
export function listDecisions(params) {
  return request.get('/decisions', { params });
}

/** 决策详情（含 options/factors/messages） */
export function getDecision(id) {
  return request.get(`/decisions/${id}`);
}

/** 回答 AI 追问 */
export function answerDecision(id, content) {
  return request.post(`/decisions/${id}/answer`, { content });
}

/**
 * 调整因素权重后复算倾向
 * @param {Array<{id:number, weight:number}>} factors
 */
export function updateFactors(id, factors) {
  return request.post(`/decisions/${id}/factors`, { factors });
}

/** 记录最终选择 */
export function chooseOption(id, optionId) {
  return request.post(`/decisions/${id}/choose`, { option_id: optionId });
}

/** 取消决策 */
export function cancelDecision(id) {
  return request.post(`/decisions/${id}/cancel`);
}

/**
 * 提交事后反馈
 * @param {{satisfaction:number, feedback?:string}} data satisfaction: 1~5
 */
export function submitResult(id, data) {
  return request.post(`/decisions/${id}/result`, data);
}

/** 查看复盘 */
export function getResult(id) {
  return request.get(`/decisions/${id}/result`);
}

/** 生成 / 取消分享 */
export function shareDecision(id) {
  return request.post(`/decisions/${id}/share`);
}

export function unshareDecision(id) {
  return request.delete(`/decisions/${id}/share`);
}

/** 分享页数据（免登录） */
export function getSharedDecision(token) {
  return request.get(`/share/${token}`);
}
